/**
 * Created by TzuHsing on 2020-10-13
 */
import React, {Component} from 'react'
import {Button, message, Table} from 'antd'
import './style.css'
import {changeToDecimal} from '../../../util'
// import AddPackage from './AddPackage'
import NewPackageModal from './newPackageModal'
import {DISABLE, ENABLE} from '../constants'

class PackageSetting extends Component {
  constructor() {
    super()
    this.resetState = this.resetState.bind(this)
    this.updatePackage = this.updatePackage.bind(this)
  }

  state = {
    allowPackage: [],
    disallowPackage: [],
    isLoading: false,
    typingPackageName: '',
    typingPackagePrice: '',
    typingPackageTime: '',
    isBindAfterAdd: false,
    purchaseStartTime: '00:00:00', // 新增限时开始时间
    purchaseEndTime: '00:00:00', // 新增限时结束时间
    purchaseWeekday: ['1', '1', '1', '1', '1', '1', '1'], // 新增选择日期
    isPurchaseLimitEnabled: false,

    visible: false,
  }

  async componentDidMount() {
    this.setState({ isLoading: true }, async () => {
      this.updatePackage()
    })
  }

  async updatePackage() {
    await this.props.fetchAllPackage()
    await this.props.fetchCurrentPackage(this.props.record.table_id)
    const { allowPackage, allPackage } = this.props
    const unAssignList = allPackage.filter((item) => {
      let isNotSame = true
      for (let i = 0; i < allowPackage.length; i++) {
        if (allowPackage[i].id === item.id) {
          isNotSame = false
          break
        }
      }
      return isNotSame
    })
    this.setState({
      allowPackage: allowPackage,
      disallowPackage: unAssignList,
      isLoading: false,
    })
  }

  handleSwitchPackage(isAllow, id) {
    const { allowPackage, disallowPackage } = this.state
    this.setState({ isLoading: true })
    if (allowPackage.length > 0) {
      const aps = allowPackage.filter((item) => {
        if (isAllow && +item.id === +id) {
          return false
        } else {
          return true
        }
      })
      let aIds = aps.map((item) => item.id)
      if (aIds.length == 0) {
        aIds = disallowPackage.map((item) => item.id)
      }
        if (!isAllow) {
            aIds.push(id)
        }
      this.postRequest(
        isAllow && aps.length == 0 ? DISABLE : ENABLE,
        isAllow,
        aIds,
        id
      )
    } else {
      this.postRequest(ENABLE, isAllow, [id], id)
    }
  }

  postRequest(postEnabled, isAllow, aIds, targetId) {
    const { allowPackage, disallowPackage } = this.state
    console.log(this.props)
    this.props.fetchBindPackage(
      {
        prepaid_ids: aIds,
        table_ids: [this.props.record.table_id],
        is_enabled: postEnabled,
      },
      (isSuccess) => {
        if (isSuccess) {
          let allowItem = {}
          let newAllowPackage, newDisallowPackage
          if (isAllow) {
            newAllowPackage = allowPackage.filter((item) => {
              if (+item.id === +targetId) {
                allowItem = item
                return false
              } else {
                return true
              }
            })
            newDisallowPackage = [...disallowPackage, allowItem]
          } else {
            newDisallowPackage = disallowPackage.filter((item) => {
              if (+item.id === +targetId) {
                allowItem = item
                return false
              } else {
                return true
              }
            })
            newAllowPackage = [...allowPackage, allowItem]
          }
          this.setState({
            allowPackage: newAllowPackage,
            disallowPackage: newDisallowPackage,
            isLoading: false,
          })
        } else {
          this.setState({ isLoading: false })
        }
      }
    )
  }

  returnCurrentColumns(isAllow) {
    return [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        width: 80,
        defaultSortOrder: 'descend',
        sorter: (a, b) => (+a.id > +b.id ? 1 : -1),
      },
      {
        title: '套餐名',
        dataIndex: 'name',
        key: 'name',
        width: 140,
      },
      {
        title: '价格(元)',
        dataIndex: 'amount',
        key: 'amount',
        width: 90,
        render: (text, record) => <span>{record.amount / 100}</span>,
      },
      {
        title: '时长(分钟)',
        dataIndex: 'duration',
        key: 'duration',
        width: 100,
        render: (text, record) => (
          <span>{+changeToDecimal(+record.duration / 60)}</span>
        ),
      },
      {
        title: '限时购买使用',
        dataIndex: 'purchaseWeekday',
        key: 'purchaseWeekday',
        render: (text, record) => {
          const showText = this.props.timeLimitText(record)
          return <span>{showText}</span>
        },
      },
      {
        title: '操作',
        key: 'action',
        width: 80,
        render: (text, record) => (
          <div onClick={() => this.handleSwitchPackage(isAllow, record.id)}>
            {isAllow ? (
              <Button type="primary" danger>
                关闭
              </Button>
            ) : (
              <Button type="primary">启用</Button>
            )}
          </div>
        ),
      },
    ]
  }

  resetState() {
    this.setState({
      typingPackageName: '',
      typingPackagePrice: '',
      typingPackageTime: '',
      isLoading: false,
    })
  }

  handleCreatePackage = async () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        const {
          typingPackageName,
          typingPackagePrice,
          typingPackageTime,
          isBindAfterAdd,
          purchaseStartTime,
          purchaseEndTime,
          purchaseWeekday,
          isPurchaseLimitEnabled,
        } = this.state
        const isPromiseChange =
          /^\d+(\.\d{1,2})?$/.test(typingPackagePrice) &&
          /^\d+(\.\d{1,2})?$/.test(typingPackageTime)
        if (
          typingPackageName &&
          typingPackagePrice !== undefined &&
          !!typingPackageTime !== undefined &&
          isPromiseChange
        ) {
          const club = sessionStorage.getItem('club_id')
          let data = {
            club_id: +club,
            name: typingPackageName,
            amount: +typingPackagePrice * 100,
            duration: +typingPackageTime * 60,
            isPurchaseLimitEnabled: isPurchaseLimitEnabled ? 1 : 0,
          }
          if (isPurchaseLimitEnabled) {
            data = {
              ...data,
              purchaseStartTime,
              purchaseEndTime,
              purchaseWeekday: parseInt(purchaseWeekday.reverse().join(''), 2),
            }
          }
          this.props.fetchAddPackage(data, async (isSuccess, res) => {
            if (isSuccess) {
              if (isBindAfterAdd) {
                console.log('res:', res)
                this.props.fetchBindPackage(
                  {
                    prepaid_ids: [res.data[0].id + ''],
                    table_ids: [this.props.record.table_id],
                    is_enabled: ENABLE,
                  },
                  async () => {
                    await this.updatePackage()
                    this.resetState()
                  }
                )
              } else {
                await this.updatePackage()
                this.resetState()
              }
            } else {
              this.setState({ isLoading: false }, () =>
                message.error(res ? res.detail : '服务暂不可用')
              )
            }
          })
        } else {
          this.setState({ isLoading: false }, () => message.error('请输入完整'))
        }
      }
    )
  }

  setTypingInfo = (typingAttr, value) => {
    this.setState(() => ({ [typingAttr]: value }))
  }
  setTypingSwitch = (typingAttr, value) => {
    this.setState((preState) => ({ [typingAttr]: !preState[typingAttr] }))
  }

  // 关闭新建套餐模态窗
  handleCancel = () => {
    this.setState({
      visible: false,
    })
  }

  render() {
    const { isLoading, allowPackage, disallowPackage } = this.state
    const columns1 = this.returnCurrentColumns(true)
    const columns2 = this.returnCurrentColumns(false)
    return (
      <div
        className={'packageSetting'}
        style={{ width: '100%', height: '100%' }}
      >
        {/* <AddPackage
          {...this.state}
          setTypingInfo={(typingAttr, value) =>
            this.setTypingInfo(typingAttr, value)
          }
          setTypingSwitch={(typingAttr, value) =>
            this.setTypingSwitch(typingAttr, value)
          }
          handleCreatePackage={() => this.handleCreatePackage()}
        /> */}
        <div>
          <Button
            type="primary"
            onClick={() => {
              this.setState({
                visible: true,
              })
            }}
          >
            新建套餐
          </Button>
        </div>
        <div className="handleList-box">
          <div className="enablePackage">
            <h3 style={{ marginTop: '0.5em' }}>启用中套餐</h3>
            <Table
              rowKey="id"
              bordered
              columns={columns1}
              loading={isLoading}
              dataSource={allowPackage}
              pagination={{ pageSize: 9 }}
            />
          </div>
          <div className="unablePackage">
            <h3 style={{ marginTop: '0.5em' }}>未启用套餐</h3>
            <Table
              rowKey="id"
              bordered
              columns={columns2}
              loading={isLoading}
              dataSource={disallowPackage}
              pagination={{ pageSize: 9 }}
            />
          </div>
        </div>

        {this.state.visible && (
          <NewPackageModal
            visible={this.state.visible}
            handleCancelPackage={this.handleCancel}
            updatePackageView={this.updatePackage}
            {...this.props}
          ></NewPackageModal>
        )}
      </div>
    )
  }
}

export default PackageSetting



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/packageSetting.js